import { useEffect, useMemo } from 'react';
import { homeActions, useHomeSlice, initialHomeState } from '../client/pages/Home/slice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { CourtSettings, SportType } from '../types';
import { getAggregatedOperatingHours } from '../utils/slots';

const FALLBACK_HOURS = '6am–11pm';

function useCourtSettingsState() {
  useHomeSlice();
  const dispatch = useAppDispatch();
  const { courtSettings, courtSettingsLoading } = useAppSelector((s) => s.home ?? initialHomeState);

  useEffect(() => {
    if (courtSettings.length === 0 && !courtSettingsLoading) {
      dispatch(homeActions.fetchCourtSettingsRequest());
    }
  }, [dispatch, courtSettings.length, courtSettingsLoading]);

  return { courtSettings, courtSettingsLoading };
}

/** Public API already returns enabled courts only. */
export function useEnabledCourtSettings(): CourtSettings[] {
  const { courtSettings } = useCourtSettingsState();
  return courtSettings;
}

export function useEnabledSports(): SportType[] {
  const courtSettings = useEnabledCourtSettings();
  return useMemo(() => courtSettings.map((s) => s.sport), [courtSettings]);
}

export function useCourtOperatingHours(): string {
  const courtSettings = useEnabledCourtSettings();
  return useMemo(
    () => getAggregatedOperatingHours(courtSettings) ?? FALLBACK_HOURS,
    [courtSettings],
  );
}
